/**
 * The valid recipe types
 * @type {Object}
 */
const recipeTypes = {
    user: {
        id: 'user',
        name: UncannyAutomator.i18n.recipeType.userRecipeName,
        description: UncannyAutomator.i18n.recipeType.userRecipeDescription,
    },
    anonymous: {
        id: 'anonymous',
        name: UncannyAutomator.i18n.recipeType.everyoneRecipeName,
        description: UncannyAutomator.i18n.recipeType.everyoneRecipeDescription,
    },
};

export default recipeTypes;
